import { AtomicTabManager } from "@coveo/atomic-react";
import { useStyleTabs } from "./useStyleTabs";

export const CoveoTabs = () => {
  useStyleTabs();

  return (
    <div className="mt-20">
      <AtomicTabManager>
        {/* @ts-expect-error web-components */}
        <atomic-tab name="all" label="All" expression="" />
        {/* @ts-expect-error web-components */}
        <atomic-tab
          name="articles"
          label="Articles"
          expression={'@articlemediatype==("Articles")'}
        />
        {/* @ts-expect-error web-components */}
        <atomic-tab
          name="podcasts"
          label="Podcasts"
          expression={'@articlemediatype==("Podcasts")'}
        />
        {/* @ts-expect-error web-components */}
        <atomic-tab
          name="videos"
          label="Videos"
          expression={'@articlemediatype==("Videos")'}
        />
      </AtomicTabManager>
    </div>
  );
};
